let loadedConfig: Config = undefined as unknown as Config;

const getConfig = async (): Promise<Config> => {
  if (loadedConfig) return loadedConfig;

  const response = await fetch('/env');
  const body = await response.json();
  if (response.status !== 200) {
    throw Error(body.message);
  }
  loadedConfig = body;
  return body;
};

export default getConfig;

export function useConfig(): Config | undefined {
  return loadedConfig;
}

export function getLoadedConfig(): Config {
  if (!loadedConfig) {
    throw new Error('Config not loaded yet');
  }
  return loadedConfig;
}

export interface Config {
  homeUrl: string;
  apiUrl: string;
  authorityUrl: string;
  version: string;
  env: string;
  clientId: string;
  scope: string;
  favoritterCollectionId: string;
  favoritterLabel: string;
  defaultCollectionId: string;
}
